// import React, { useEffect, useRef } from "react";

// const TranslateComponent = () => {
//     const googleTranslateRef = useRef(null);

//     useEffect(() => {
//         // 1. Define callback FIRST — use a fixed div ID, not ref
//         //    because Google calls this async, ref might be stale
//         window.googleTranslateElementInit = () => {
//             if (!window.google?.translate?.TranslateElement) return;
//             new window.google.translate.TranslateElement(
//                 {
//                     pageLanguage: "en",
//                     layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//                 },
//                 "google_translate_element" // ✅ use ID string, not ref
//             );
//         };

//         // 2. If script already loaded (component remounted), call init directly
//         if (window.google?.translate?.TranslateElement) {
//             window.googleTranslateElementInit();
//             return;
//         }

//         // 3. If script tag doesn't exist yet, inject it
//         const existingScript = document.getElementById("google-translate-script");
//         if (!existingScript) {
//             const script = document.createElement("script");
//             script.id = "google-translate-script";
//             script.src =
//                 "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//             script.async = true;
//             document.body.appendChild(script);
//         }

//         // ❌ Don't delete the callback on cleanup — Google may call it async
//         // return () => { delete window.googleTranslateElementInit; };
//     }, []);

//     return (
//         <div>
//             <div id="google_translate_element" ref={googleTranslateRef}></div>
//         </div>
//     );
// };

// export default TranslateComponent;

import React, { useEffect } from "react";

const TranslateComponent = () => {

    useEffect(() => {
        window.googleTranslateElementInit = () => {
            if (!window.google?.translate?.TranslateElement) return;
            new window.google.translate.TranslateElement(
                {
                    pageLanguage: "en",
                    includedLanguages: "en,es,fr,it,pt",
                    layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                },
                "google_translate_element"
            );
        };

        const existingScript = document.getElementById("google-translate-script");
        if (!existingScript) {
            const script = document.createElement("script");
            script.id = "google-translate-script";
            script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            document.body.appendChild(script);
        } else if (window.google?.translate?.TranslateElement) {
            window.googleTranslateElementInit();
        }
    }, []);

    return (
        <div
            id="google_translate_element"
            style={{
                position: "fixed",
                bottom: "30px",     // floating at bottom
                right: "30px",      // floating at right
                zIndex: 9999,       // above everything
            }}
        />
    );
};

export default TranslateComponent;